import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { cmxDateTime, HttpMethods, objectUtils } from '@codametrix/ui-common';
import { api } from '../core/net';
import { caseConfigFieldsBySection, sectionDictionaries } from '../reducers/state/case-config/case-config';
import { CaseConfig } from './action-types';
import { showFeedback } from './ui';
const selectConfigSection = createAction(CaseConfig.SELECT_CASE_CONFIG_SECTION);
const reduxSaveCaseConfigs = createAction(CaseConfig.REDUX_SAVE_CASE_CONFIGS);
const loadCaseConfigOptions = createAsyncThunk(CaseConfig.LOAD_CASE_CONFIG_OPTIONS, async (payload, _thunkAPI)=>{
    const { section, activeTenantId } = payload;
    const dictionaryNames = sectionDictionaries[section];
    let configOptions = {};
    if (dictionaryNames) {
        for (const [fieldKey, dictionaryInfo] of Object.entries(dictionaryNames)){
            const { dictionaryName, columnName } = dictionaryInfo;
            const searchParams = new URLSearchParams({
                tenantId: activeTenantId,
                derivedIndicator: 'true',
                effectiveDate: cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE),
                dictionaryName: dictionaryName,
                columnName: columnName
            });
            const config = await api({
                endpoint: `/dictionary/row/v2?${searchParams.toString()}`,
                init: {
                    method: HttpMethods.GET
                }
            });
            const fieldOptions = config.rowValues.map((row)=>{
                return {
                    label: row[columnName],
                    value: row[columnName]
                };
            });
            configOptions[fieldKey] = objectUtils.uniqWith(fieldOptions, (a, b)=>a.value === b.value);
        }
    }
    return configOptions;
});
const listCaseConfigurations = createAsyncThunk(CaseConfig.LIST_CASE_CONFIGURATIONS, async (payload, { dispatch })=>{
    await dispatch(loadCaseConfigOptions({
        ...payload
    }));
    const searchParams = new URLSearchParams({
        tenantId: payload.tenantId,
        serviceLineName: payload.serviceLine.name ? payload.serviceLine.name : 'Radiology'
    });
    const configs = await api({
        endpoint: `/caseconfig?${searchParams.toString()}`,
        init: {
            method: HttpMethods.GET
        }
    });
    dispatch(reduxSaveCaseConfigs(configs));
    let dataObject = {};
    const fields = caseConfigFieldsBySection[payload.section];
    fields.forEach((field)=>{
        const matchingConfig = configs.find((config)=>config.configurationKey === field.key);
        if (matchingConfig) {
            dataObject[matchingConfig.configurationKey] = matchingConfig.configurationValues[0].configurationValue || '';
        }
    });
    return dataObject;
});
const saveCaseConfiguration = createAsyncThunk(CaseConfig.SAVE_CASE_CONFIGURATION, async (payload, { dispatch, rejectWithValue })=>{
    const searchParams = new URLSearchParams({
        tenantId: payload.tenantId,
        serviceLineName: payload.serviceLine.name ? payload.serviceLine.name : 'Radiology'
    });
    try {
        const config = await api({
            endpoint: `/caseconfig?${searchParams.toString()}`,
            init: {
                method: HttpMethods.PUT
            },
            body: payload.caseConfigs
        });
        dispatch(showFeedback({
            id: Date.now(),
            message: `Case Config Saved.`,
            dismissable: true,
            className: 'feedback-working'
        }));
        return config;
    } catch (error) {
        return rejectWithValue({
            errors: error?.errors
        });
    }
});
const syncActions = {
    selectConfigSection,
    reduxSaveCaseConfigs
};
export { listCaseConfigurations, saveCaseConfiguration, syncActions, loadCaseConfigOptions };
